import { Link } from 'react-router-dom';
import { hotComics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function HotRecommend() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              热门推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              千万漫迷的共同选择
            </p>
          </div>
          <Link
            to="/category/rexue"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {hotComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/rexue"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
          >
            查看全部热门推荐 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}